import {
    Button,
    FormControl,
    IconButton,
    Input,
    InputAdornment,
    InputLabel,
    Paper,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useState } from 'react';
import { PostAdd, Search } from '@mui/icons-material';
import * as R from 'ramda';
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        alignItems: 'center',
        padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
        marginBottom: theme.spacing(2),
    },
    leftHeader: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    button: {
        fontFamily: 'IranSans !important'
    },
    searchIcon: {
        position: 'absolute',
    },
}));

const ContainerHeader = (props) => {
    const classes = useStyles();
    const {
        titleBtn,
        addBtnAction,
        headerTitle,
        filterAction,
        data,
        backBtnAction = R.T,
        backBtnTitle,
    } = props;
    const [searchText, setSearchText] = useState('');

    const { backBtn = false } = data;

    const handleChange = (event) => {
        setSearchText(event.target.value);
    };
    return (
        <Paper className={classes.root}>
            <h3 className="m-0">{headerTitle}</h3>
            <div className={classes.leftHeader}>
                {/*{data.filter ? (*/}
                {/*    <FormControl className={clsx(classes.margin, classes.textField)}>*/}
                {/*        <InputLabel htmlFor="standard-adornment-password">جسنجو</InputLabel>*/}
                {/*        <Input*/}
                {/*            value={searchText}*/}
                {/*            onChange={handleChange}*/}
                {/*            endAdornment={*/}
                {/*                <InputAdornment position="end">*/}
                {/*                    <IconButton onClick={filterAction}>*/}
                {/*                        <Search />*/}
                {/*                    </IconButton>*/}
                {/*                </InputAdornment>*/}
                {/*            }*/}
                {/*        />*/}
                {/*    </FormControl>*/}
                {/*) : (*/}
                {/*    false*/}
                {/*)}*/}
                {backBtn ? (
                    <Button
                        onClick={backBtnAction}
                        variant="outlined"
                        color="secondary"
                        className={classes.button}
                        // startIcon={<PostAdd />}
                    >
                        {backBtnTitle || 'بازگشت '}
                    </Button>
                ) : (
                    false
                )}
                {data.addBtn ? (
                    <Button
                        onClick={addBtnAction}
                        variant="outlined"
                        color="primary"
                        className={classes.button}
                        startIcon={<PostAdd />}
                    >
                        {titleBtn}
                    </Button>
                ) : (
                    false
                )}
            </div>
        </Paper>
    );
};
export default ContainerHeader;
